import { Link, useLocation } from "react-router-dom";
import "./UserInfo.css";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useState, useEffect, useCallback } from "react";
// Component --------------------------------------------
import EmploymentDetails from "../EmploymentDetails/EmploymentDetails";
import BackgroundVerification from "../BackgroundVerification/Index";
import UserPermission from "../userPermission/UserPermission";
import LeaveBalanceDetails from "../LeaveBalanceDetails/LeaveBalanceDetails";
import PenaltyOvertimeDetails from "../PenaltyOvertimeDetails/PenaltyOvertimeDetails";
import DocumentType from "../DocumentType/DocumentType";
import AttendanceDetails from "../AttendanceDetails/AttendanceDetails";
import CustomDetails from "../CustomDetails/customDetails";
import SalaryDetails from "../SalaryDetails/SalaryDetails";
import TaxDeclaration from "../TaxDeclaration";
// Component --------------------------------------------
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { Form, Row, Col } from "react-bootstrap";
import ButtonCom from "../../../components/button/button";
import Table from "../../../components/table/TableMui";
import Switch from "@mui/material/Switch";
import UserImg from "../../../assets/Images/user-avatar.jpg";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import { AgGridReact } from "ag-grid-react";
import { CiUser } from "react-icons/ci";
import { RiEdit2Line } from "react-icons/ri";
import { MdCastForEducation } from "react-icons/md";
import { CgFileDocument } from "react-icons/cg";
import { HiOutlineLocationMarker } from "react-icons/hi";
import { BsBank } from "react-icons/bs";
import { FiPlus } from "react-icons/fi";

import CheckImg from "../../../assets/Images/check.png";

import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import WidgetsButton from "../../../components/Widgets/button";
import Spinner from "react-bootstrap/Spinner";

import {
  commonGetData,
  commonGetDataOne,
  commonGetDataTwo,
  commonSaveData,
  commonSaveDataOne,
  initState,
  initCommonState,
} from "../../../redux/slices/commonSlice";
import { noAuthGet2, noAuthGet5 } from "../../../redux/slices/noAuthSlice";
import { useDispatch, useSelector } from "react-redux";
import {
  getEmployeeInidvidualStaffListPath,
  adminGetBloodGroup,
  getStatesPath,
  getQualificationsPath,
  updatePersonalDetailsPath,
  updateEnableFacePath,
  getEmployeeBankListFuncPath,
  updateBankAccountDetailsPath,
  updateEmployeeBankAccountsPath,
  deactivateEmployeePath,
  updateEmployeeBankChequePath,
  updateAddressDetailsPath,
  updateQualificationDetailsPath,
} from "../../../services/config";

import { imageToBase64 } from "../../../services/commonServices";
import { HasPermission } from "../../../services/hasPermission";
import { useGlobalToast } from "../../../stopOldToastGlobally.js";

const userInfoList = [
  {
    name: "Personal Details",
    isAccess: HasPermission("Personal Details", "view"),
  },
  {
    name: "Employment Details",
    isAccess: HasPermission("Employment Details", "view"),
  },
  { name: "Asserts", isAccess: HasPermission("Asserts", "view") },
  {
    name: "Background Verification",
    isAccess: HasPermission("Background Verification", "view"),
  },
  { name: "Bank Account", isAccess: HasPermission("Bank Account", "view") },
  {
    name: "User Permission",
    isAccess: HasPermission("User Permission", "view"),
  },
  {
    name: "Attendance Details",
    isAccess: HasPermission("Attendance Details", "view"),
  },
  { name: "Salary Details", isAccess: HasPermission("Salary Details", "view") },
  {
    name: "Leave & Balance Details",
    isAccess: HasPermission("Leave & Balance Details", "view"),
  },
  {
    name: "Penalty & Overtime Details",
    isAccess: HasPermission("Penalty & Overtime Details", "view"),
  },
  {
    name: "Tax Declarations",
    isAccess: HasPermission("Tax Declarations", "view"),
  },
  { name: "Document", isAccess: HasPermission("Documents", "view") },
];

const UserInfo = () => {
  const user = localStorage.getItem("user_data")
    ? JSON.parse(localStorage.getItem("user_data"))
    : null;
  const location = useLocation();
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);
  const toast = useGlobalToast();
  const [userDetails, setUserDetails] = useState([]);
  const [userProfile, setUserProfile] = useState("");
  const [staffImage, setStaffImage] = useState("");

  const [isActiveUser, setIsActiveUser] = useState("");
  const [isEnableFace, setEnableFace] = useState("");

  const getUserDetails = useCallback(() => {
    const employeeId = location.pathname.split("/").pop();
    const url = `${getEmployeeInidvidualStaffListPath}${employeeId}`;
    dispatch(commonGetDataOne(url));
    localStorage.setItem("employee-id", employeeId);
  }, [location.pathname]);

  useEffect(() => {
    if (commonState.commonGetOneSuccess) {
      setUserDetails(commonState.commonGetOneData);
      setUserProfile(
        commonState.commonGetOneData
          ? commonState.commonGetOneData[0]?.personalDetails?.profileImage
          : ""
      );
      setStaffImage(
        commonState.commonGetOneData
          ? commonState.commonGetOneData[0]?.personalDetails?.staffImage
          : ""
      );
      setIsActiveUser(commonState.commonGetOneData[0].status);
      setEnableFace(
        commonState.commonGetOneData[0]?.personalDetails?.enableFace
      );
      dispatch(initState());
    }
    if (commonState.commonSuccess) {
      toast.success(commonState.commonMessage);
      dispatch(initCommonState());
    }
  }, [commonState.commonGetOneSuccess, commonState.commonSuccess, toast, dispatch]);

  useEffect(() => {
    getUserDetails();
  }, [getUserDetails]);

  const [highlightTap, setHighlightTap] = useState(0);

  useEffect(() => {
    const hash = window.location.hash.slice(1);
    if (hash === "tax-declarations") {
      const taxIndex = userInfoList.findIndex(item => item.name === "Tax Declarations");
      if (taxIndex !== -1) {
        setHighlightTap(taxIndex);
      }
    }

    const handleHashChange = () => {
      const newHash = window.location.hash.slice(1);
      if (newHash === "tax-declarations") {
        const taxIndex = userInfoList.findIndex(item => item.name === "Tax Declarations");
        if (taxIndex !== -1) {
          setHighlightTap(taxIndex);
        }
      }
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleActiveInactiveChange = (event) => {
    const newStatus = event.target.value;
    console.log("Changing status to:", newStatus);
    console.log("Current employee data:", userDetails[0]);
    
    setIsActiveUser(newStatus);
    
    if (!userDetails || !userDetails[0] || !userDetails[0].staffId) {
      toast.error("Employee data not loaded yet");
      return;
    }
    
    const data = {
      path: deactivateEmployeePath,
      data: {
        userId: user.user_id,
        staffId: userDetails[0].staffId,
        isActiveUser: newStatus,
      },
    };
    
    console.log("Sending to API:", data);
    dispatch(commonSaveData(data));
  };

  const handleFaceChange = (event) => {
    setEnableFace(event.target.value);
    const data = {
      path: updateEnableFacePath,
      data: {
        userId: user.user_id,
        staffId: userDetails[0].staffId,
        enableFace: event.target.value,
      },
    };
    dispatch(commonSaveData(data));
  };

  const listItem = [
    {
      item: (
        <PersonalDetails
          user={user}
          userDetails={userDetails}
          commonState={commonState}
          getUserDetails={getUserDetails}
        />
      ),
      isAccess: HasPermission("Personal Details", "view"),
    },
    {
      item: (
        <EmploymentDetails
          user={user}
          userDetails={userDetails}
          commonState={commonState}
          getUserDetails={getUserDetails}
        />
      ),
      isAccess: HasPermission("Employment Details", "view"),
    },
    {
      item: (
        <CustomDetails
          user={user}
          userDetails={userDetails}
          commonState={commonState}
        />
      ),
      isAccess: HasPermission("Asserts", "view"),
    },
    {
      item: (
        <BackgroundVerification
          user={user}
          userDetails={userDetails}
          commonState={commonState}
        />
      ),
      isAccess: HasPermission("Background Verification", "view"),
    },
    {
      item: (
        <BankAccount
          user={user}
          userDetails={userDetails}
          commonState={commonState}
          getUserDetails={getUserDetails}
        />
      ),
      isAccess: HasPermission("Bank Account", "view"),
    },
    {
      item: (
        <UserPermission
          user={user}
          user_details={userDetails}
          commonState={commonState}
        />
      ),
      isAccess: HasPermission("User Permission", "view"),
    },
    {
      item: (
        <AttendanceDetails
          user={user}
          userDetails={userDetails}
          commonState={commonState}
        />
      ),
      isAccess: HasPermission("Attendance details", "view"),
    },
    {
      item: (
        <SalaryDetails userDetails={userDetails} commonState={commonState} />
      ),
      isAccess: HasPermission("Salary details", "view"),
    },
    {
      item: (
        <LeaveBalanceDetails
          user={user}
          userDetails={userDetails}
          commonState={commonState}
        />
      ),
      isAccess: HasPermission("Leave & Balance Details", "view"),
    },
    {
      item: (
        <PenaltyOvertimeDetails
          user={user}
          userDetails={userDetails}
          commonState={commonState}
        />
      ),
      isAccess: HasPermission("Penalty & Overtime Details", "view"),
    },
    {
      item: (
        <TaxDeclaration
          user={user}
          userDetails={userDetails}
          commonState={commonState}
        />
      ),
      isAccess: HasPermission("Tax Declarations", "view"),
    },
    {
      item: (
        <DocumentType
          user={user}
          userDetails={userDetails}
          commonState={commonState}
        />
      ),
      isAccess: HasPermission("Documents", "view"),
    },
  ];

  const displayName =
    userDetails.length
      ? userDetails[0].full_name.length > 22
        ? userDetails[0].full_name.slice(0, 19) + "..."
        : userDetails[0].full_name
      : null;
  
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("emp-redirect")) {
      localStorage.removeItem("emp-redirect");
    }
  }, []);

  // Get the base path from environment or config
  const employeeListPath = "/empmanagement";

  return (
    <>
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        className="toast-custom"
      />

      <div className="userInfo">
        <div className="userInfo-Body p-2">
          <div className="userInfo-Body-left pb-3">
            <div className="userInfo-left-item">
              <div className="header">
                <Link to={`${employeeListPath}#0`}>
                  <ArrowBackIcon
                    sx={{ scale: 1 }}
                    style={{ color: "gray", marginLeft: "10px" }}
                  />
                  <span className="color-white">Employee Details</span>
                </Link>
              </div>

              <div className="profile-container">
                <img
                  src={userProfile || UserImg}
                  alt="profileImage"
                />
                <h3 className="color-white">
                  <span
                    className={`name-tooltip ${open ? "open" : ""}`}
                    tabIndex={0}
                    aria-label={userDetails.length && userDetails[0].full_name}
                    onClick={() => setOpen((s) => !s)}
                    onBlur={() => setOpen(false)}
                  >
                    {displayName}
                    {(userDetails.length && userDetails[0].full_name.length) > 22 && (
                      <span className="tooltip-text" role="tooltip">
                        {userDetails.length && userDetails[0].full_name}
                      </span>
                    )}
                  </span>
                </h3>

                <span>
                  {userDetails.length ? userDetails[0].employeeId : null}
                </span>
                <div className="d-flex align-items-center justify-content-center gap-2">
                  <select
                    className={
                      isActiveUser == "1"
                        ? "active-inactive"
                        : "inactive-active"
                    }
                    value={isActiveUser}
                    onChange={handleActiveInactiveChange}
                  >
                    <option value="1">Active</option>
                    {/* <option value="0">InActive</option> */}
                  </select>
                </div>
              </div>

              <div className="list-container pb-3">
                {userInfoList.length > 0
                  ? userInfoList.map(
                    (item, i) =>
                      item.isAccess && (
                        <div
                          key={i}
                          className={
                            highlightTap === i
                              ? "user-info-list active"
                              : "user-info-list"
                          }
                          onClick={() => setHighlightTap(i)}
                        >
                          <p>
                            {item.name}
                            <ArrowForwardIosIcon className="list-icon" />
                          </p>
                        </div>
                      )
                  )
                  : null}
              </div>
            </div>
          </div>

          <div className="userInfo-Body-right">
            {commonState.commonGetOneLoading && (
              <div className="d-flex justify-content-center align-items-center" style={{ height: "100vh" }}>
                <Spinner animation="border" variant="primary" />
              </div>
            )}
            {listItem.length > 0
              ? listItem.map(
                (item, i) =>
                  item.isAccess && (
                    <div key={i}>
                      {highlightTap === i && userDetails.length ? (
                        <div key={i}>{item.item}</div>
                      ) : (
                        <></>
                      )}
                    </div>
                  )
              )
              : null}
          </div>
        </div>
      </div>
    </>
  );
};

const PersonalDetails = ({
  user,
  userDetails,
  commonState,
  getUserDetails,
}) => {
  return (
    <div className="body-container">
      <div className="page-body">
        {userDetails.length && (
          <BasicDetails
            userDetails={userDetails}
            user={user}
            getUserDetails={getUserDetails}
          />
        )}
      </div>
    </div>
  );
};

const BasicDetails = ({ userDetails, user, getUserDetails }) => {
  const dispatch = useDispatch();
  const commonState = useSelector((state) => state.common);
  const noAuthState = useSelector((state) => state.noAuth);
  const toast = useGlobalToast();

  const [states, setStates] = useState([]);
  const [qualification_, setQualification_] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [touchedFields, setTouchedFields] = useState({});

  const [isEnableFace, setEnableFace] = useState("");
  const [staffImage, setStaffImage] = useState("");

  const getBloodGroup = useCallback(() => {
    dispatch(commonGetData(adminGetBloodGroup));
    dispatch(noAuthGet5(getStatesPath));
    dispatch(noAuthGet2(getQualificationsPath));
    setEnableFace(userDetails[0]?.personalDetails?.enableFace);
    setStaffImage(
      userDetails ? userDetails[0]?.personalDetails?.staffImage : ""
    );
  }, [dispatch, userDetails]);

  useEffect(() => {
    getBloodGroup();
  }, [getBloodGroup]);

  useEffect(() => {
    if (noAuthState.noAuthGet5Success) {
      const newArr = noAuthState.noAuthGet5Data.map((v) => {
        return { label: v.stateName, value: v.stateId };
      });
      setStates(newArr);
    }

    if (noAuthState.noAuthGet2Success) {
      const newArr = noAuthState.noAuthGet2Data.map((v) => {
        return { label: v.qualificationName, value: v.qualificationId };
      });
      setQualification_(newArr);
    }
  }, [noAuthState, noAuthState.noAuthGet5Success, noAuthState.noAuthGet2Success]);

  const [dialogForm, setDialogForm] = useState(false);
  const [formType, setFormType] = useState(null);

  const [updateStaff, setUpdateStaff] = useState({
    profileImage: userDetails[0]?.personalDetails?.profileImage,
    staffImage: userDetails[0]?.personalDetails?.staffImage,
    userId: user.user_id,
    staffId: userDetails[0]?.staffId,
    staff_name: userDetails[0]?.full_name || "",
    staff_mobile: userDetails[0]?.mobile_number || "",
    staff_personal_email: userDetails[0]?.personalDetails?.personalEmail || "",
    dob: userDetails[0]?.personalDetails?.dob || "",
    gender: userDetails[0]?.gender || "",
    marital_status: userDetails[0]?.personalDetails?.maritalStatus || "",
    marriageDate: userDetails[0]?.personalDetails?.marriageDate
      ? userDetails[0]?.personalDetails?.marriageDate.substring(0, 10)
      : "",
    spouseName: userDetails[0]?.personalDetails?.spouseName || "",
    emerg_cont_name: userDetails[0]?.personalDetails?.emergency_contact_name || "",
    emerg_cont_mobile: userDetails[0]?.personalDetails?.emergency_contact_mobile || "",
    emerg_cont_address: userDetails[0]?.personalDetails?.emergency_contact_address || "",
    // Address -----------------------------------------------
    address: userDetails[0]?.addressDetails?.addressText || "",
    country: userDetails[0]?.addressDetails?.country || "1",
    city: userDetails[0]?.addressDetails?.city || "",
    state: userDetails[0]?.addressDetails?.state || "",
    pincode: userDetails[0]?.addressDetails?.pincode || "",
    // Government ID -----------------------------------------------
    aadharName: userDetails[0]?.personalDetails?.aadharName || "",
    aadharNumber: userDetails[0]?.personalDetails?.aadharNumber || "",
    panName: userDetails[0]?.personalDetails?.panName || "",
    panNumber: userDetails[0]?.personalDetails?.panNumber || "",
    uanNumber: userDetails[0]?.personalDetails?.uanNumber || "",
    pfAccountNumber: userDetails[0]?.personalDetails?.pfNumber || "",
    educationNum: userDetails[0]?.qualificationDetails?.educationNum || "",
    // Qualification -----------------------------------------------
    qualification: userDetails[0]?.qualificationDetails?.qualification || "",
    fromYear: userDetails[0]?.qualificationDetails?.fromYear || "",
    toYear: userDetails[0]?.qualificationDetails?.toYear || "",
    institute: userDetails[0]?.qualificationDetails?.institute || "",
    enableFace: userDetails[0]?.personalDetails?.enableFace || "",
    isActiveUser: userDetails[0]?.status || "",
  });

  // Validation functions
  const validateEmail = (email) => {
    if (!email) return true; // Optional field
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  };

  const validateMobile = (mobile) => {
    if (!mobile) return false; // Required field
    const re = /^[0-9]{10}$/;
    return re.test(mobile);
  };

  const validateAadhar = (aadhar) => {
    if (!aadhar) return false; // Required field
    const re = /^[0-9]{12}$/;
    return re.test(aadhar);
  };

  const validatePAN = (pan) => {
    if (!pan) return false; // Required field
    const re = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    return re.test(pan);
  };

  const validatePincode = (pincode) => {
    if (!pincode) return false; // Required field
    const re = /^[0-9]{6}$/;
    return re.test(pincode);
  };

  const validateYear = (year) => {
    if (!year) return false;
    const date = new Date(year);
    return date instanceof Date && !isNaN(date);
  };

  const validateName = (name) => {
    if (!name) return false;
    return name.trim().length >= 2;
  };

  const validateCity = (city) => {
    if (!city) return false;
    return city.trim().length >= 2;
  };

  const validateAddress = (address) => {
    if (!address) return false;
    return address.trim().length >= 5;
  };

  const validateInstitute = (institute) => {
    if (!institute) return false;
    return institute.trim().length >= 2;
  };

  const validateField = (name, value, formType) => {
    let error = "";

    // Check if field is empty for required fields
    const requiredFields = {
      basic: {
        staff_name: "Name is required",
        staff_mobile: "Mobile number is required",
        dob: "Date of birth is required",
        gender: "Gender is required",
      },
      govtId: {
        aadharNumber: "Aadhar number is required",
        panNumber: "PAN number is required",
      },
      address: {
        address: "Address is required",
        city: "City is required",
        state: "State is required",
        pincode: "Pincode is required",
      },
      qualification: {
        qualification: "Qualification is required",
        fromYear: "From year is required",
        toYear: "To year is required",
        institute: "Institute name is required",
      }
    };

    // Check required fields
    if (requiredFields[formType] && requiredFields[formType][name]) {
      if (!value || value.toString().trim() === "") {
        return requiredFields[formType][name];
      }
    }

    // Conditional required fields
    if (name === 'marriageDate' && updateStaff.marital_status === "1" && !value) {
      return "Marriage date is required for married employees";
    }

    if (name === 'spouseName' && updateStaff.marital_status === "1" && !value) {
      return "Spouse name is required for married employees";
    }

    // Field-specific validations
    switch (name) {
      case 'staff_name':
        if (value && !validateName(value)) {
          error = "Name must be at least 2 characters";
        }
        break;

      case 'staff_mobile':
        if (value && !validateMobile(value)) {
          error = "Mobile number must be exactly 10 digits";
        }
        break;

      case 'staff_personal_email':
        if (value && !validateEmail(value)) {
          error = "Invalid email format (e.g., name@example.com)";
        }
        break;

      case 'dob':
        if (value) {
          const dobDate = new Date(value);
          const today = new Date();
          const age = today.getFullYear() - dobDate.getFullYear();
          if (age < 18) {
            error = "Employee must be at least 18 years old";
          } else if (age > 100) {
            error = "Invalid date of birth";
          }
        }
        break;

      case 'aadharNumber':
        if (value && !validateAadhar(value)) {
          error = "Aadhar number must be exactly 12 digits";
        }
        break;

      case 'panNumber':
        if (value && !validatePAN(value)) {
          error = "Invalid PAN format (e.g., ABCDE1234F)";
        }
        break;

      case 'pincode':
        if (value && !validatePincode(value)) {
          error = "Pincode must be exactly 6 digits";
        }
        break;

      case 'fromYear':
      case 'toYear':
        if (value && !validateYear(value)) {
          error = "Invalid date format";
        }
        if (name === 'toYear' && updateStaff.fromYear && value) {
          const fromDate = new Date(updateStaff.fromYear);
          const toDate = new Date(value);
          if (toDate < fromDate) {
            error = "To year cannot be before from year";
          }
        }
        break;

      case 'emerg_cont_mobile':
        if (value && !validateMobile(value)) {
          error = "Emergency contact number must be exactly 10 digits";
        }
        break;

      case 'city':
        if (value && !validateCity(value)) {
          error = "City must be at least 2 characters";
        }
        break;

      case 'address':
        if (value && !validateAddress(value)) {
          error = "Address must be at least 5 characters";
        }
        break;

      case 'institute':
        if (value && !validateInstitute(value)) {
          error = "Institute name must be at least 2 characters";
        }
        break;

      default:
        break;
    }

    return error;
  };

  const validateForm = (type) => {
    const errors = {};
    const fields = {
      basic: ['staff_name', 'staff_mobile', 'staff_personal_email', 'dob', 'gender', 'marital_status', 'marriageDate', 'spouseName', 'emerg_cont_name', 'emerg_cont_mobile', 'emerg_cont_address'],
      govtId: ['aadharName', 'aadharNumber', 'panName', 'panNumber', 'pfAccountNumber', 'uanNumber'],
      address: ['address', 'city', 'state', 'pincode', 'country'],
      qualification: ['qualification', 'fromYear', 'toYear', 'institute']
    };

    fields[type].forEach(field => {
      const error = validateField(field, updateStaff[field], type);
      if (error) {
        errors[field] = error;
      }
    });

    setValidationErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleBlur = (e) => {
    const { name } = e.target;
    setTouchedFields(prev => ({ ...prev, [name]: true }));
    const error = validateField(name, updateStaff[name], formType);
    setValidationErrors(prev => ({ ...prev, [name]: error || "" }));
  };

  const inputsOne = [
    {
      name: "staff_name",
      label: "Name",
      placeholder: "Enter Name",
      required: true,
    },
  ];

  const inputsTwo = [
    {
      name: "staff_personal_email",
      label: "Personal Email Id",
      placeholder: "Enter Personal Email Id",
      type: "email",
    },
    {
      name: "dob",
      label: "Date Of Birth",
      placeholder: "Enter Date Of birth",
      type: "date",
      required: true,
    },
    {
      name: "gender",
      label: "Gender",
      required: true,
      chi: [
        { label: "Select gender", value: "" },
        { label: "Male", value: "1" },
        { label: "Female", value: "2" },
        { label: "Other", value: "3" },
      ],
    },
    {
      name: "marital_status",
      label: "Marital Status",
      chi: [
        { label: "Select marital status", value: "" },
        { label: "Married", value: "1" },
        { label: "Unmarried", value: "2" },
        { label: "Widow", value: "3" },
      ],
    },
    {
      name: "marriageDate",
      label: "Marriage Date",
      placeholder: "Select Date Of Marriage",
      type: "date",
      isVisible: updateStaff.marital_status === "1",
    },
    {
      name: "spouseName",
      label: "Spouse Name",
      placeholder: "Enter Spouse Name",
      type: "text",
      isVisible: updateStaff.marital_status === "1",
    },
    {
      name: "emerg_cont_name",
      label: "Emergency Contact Name",
      placeholder: "Emergency Contact Name",
    },
  ];

  const GovernmentIdsInputsOnes = [
    {
      name: "aadharName",
      label: "Aadhaar Name",
      placeholder: "Enter Aadhaar Name",
    },
    {
      name: "aadharNumber",
      label: "Aadhaar Number",
      placeholder: "Enter Aadhaar Number",
      required: true,
    },
    { name: "panName", label: "PAN Name", placeholder: "Enter PAN Name" },
    { 
      name: "panNumber", 
      label: "PAN Number", 
      placeholder: "Enter PAN Number",
      required: true,
    },
    {
      name: "pfAccountNumber",
      label: "PF Number",
      placeholder: "Enter PF Number",
    },
    { name: "uanNumber", label: "UAN Number", placeholder: "Enter UAN" },
  ];

  const AddressInfos = [
    {
      name: "address",
      label: "Address",
      placeholder: "Enter Address",
      required: true,
    },
    {
      name: "city",
      label: "City",
      placeholder: "Enter City",
      required: true,
    },
    {
      name: "state",
      label: "State",
      placeholder: "Select State",
      required: true,
      chi: states,
    },
    {
      name: "pincode",
      label: "Pincode",
      placeholder: "Enter Pin Code",
      required: true,
    },
    {
      name: "country",
      label: "Country",
      placeholder: "Select Country",
      chi: "yes",
    },
  ];

  const qualification = [
    {
      name: "qualification",
      label: "Qualification",
      placeholder: "Select Qualification",
      required: true,
    },
    {
      name: "fromYear",
      label: "From Year",
      placeholder: "Enter From Year",
      type: "date",
      required: true,
    },
    {
      name: "toYear",
      label: "To Year",
      placeholder: "Enter To Year",
      type: "date",
      required: true,
    },
    {
      name: "institute",
      label: "Institute",
      placeholder: "Enter Institute",
      required: true,
    },
  ];

  const handelChange = (e) => {
    const { name, value } = e.target;
    setUpdateStaff((pv) => ({ ...pv, [name]: value }));
    
    // Clear validation error when user starts typing
    if (validationErrors[name]) {
      setValidationErrors(prev => ({ ...prev, [name]: "" }));
    }
  };

  const preSubmit = () => {
    if (validateForm(formType)) {
      document.getElementById("submit-btn-bs-dt").click();
    } else {
      // Mark all fields as touched to show errors
      const fields = {
        basic: ['staff_name', 'staff_mobile', 'staff_personal_email', 'dob', 'gender', 'marital_status', 'marriageDate', 'spouseName', 'emerg_cont_name', 'emerg_cont_mobile', 'emerg_cont_address'],
        govtId: ['aadharName', 'aadharNumber', 'panName', 'panNumber', 'pfAccountNumber', 'uanNumber'],
        address: ['address', 'city', 'state', 'pincode', 'country'],
        qualification: ['qualification', 'fromYear', 'toYear', 'institute']
      };
      
      const touched = {};
      fields[formType].forEach(field => {
        touched[field] = true;
      });
      setTouchedFields(touched);
      
      toast.error("Please fix all validation errors before saving");
    }
  };

  const handelSubmit = (e) => {
    e.preventDefault();
    if (!validateForm(formType)) {
      toast.error("Please fix all validation errors");
      return;
    }

    if (formType === "qualification") {
      const data = {
        path: updateQualificationDetailsPath,
        data: {
          userId: user.user_id,
          staffId: updateStaff.staffId,
          qualification: updateStaff.qualification,
          from_year: updateStaff.fromYear,
          to_year: updateStaff.toYear,
          institute: updateStaff.institute,
        },
      };
      dispatch(commonSaveData(data));
    } else if (formType === "address") {
      const data = {
        path: updateAddressDetailsPath,
        data: {
          userId: user.user_id,
          staffId: updateStaff.staffId,
          address: updateStaff.address,
          city: updateStaff.city,
          state: updateStaff.state,
          pincode: updateStaff.pincode,
          country: updateStaff.country || "1",
        },
      };
      dispatch(commonSaveData(data));
    } else if (formType === "govtId") {
      const data = {
        path: updatePersonalDetailsPath,
        data: {
          userId: user.user_id,
          staffId: updateStaff.staffId,
          aadharName: updateStaff.aadharName,
          aadharNumber: updateStaff.aadharNumber,
          panName: updateStaff.panName,
          panNumber: updateStaff.panNumber,
          uanNumber: updateStaff.uanNumber,
          pfNumber: updateStaff.pfAccountNumber,
        },
      };
      dispatch(commonSaveData(data));
    } else {
      const data = {
        path: updatePersonalDetailsPath,
        data: updateStaff,
      };
      dispatch(commonSaveData(data));
    }
  };

  useEffect(() => {
    if (commonState.commonSuccess) {
      setDialogForm(false);
      setValidationErrors({});
      setTouchedFields({});
      toast.success(commonState.commonMessage);
      dispatch(initState());
      dispatch(initCommonState());
      getUserDetails();
    }
    if (commonState.commonError) {
      setDialogForm(false);
      toast.error(commonState.commonMessage);
      dispatch(initState());
      dispatch(initCommonState());
    }
  }, [commonState.commonSuccess, commonState.commonError, toast, dispatch, getUserDetails]);

  const handleObjectList = (type) => {
    setFormType(type);
    setValidationErrors({});
    setTouchedFields({});
    setDialogForm(true);
  };

  const handleFaceChange = (event) => {
    setEnableFace(event.target.checked ? "1" : "0");
    const data = {
      path: updateEnableFacePath,
      data: {
        userId: user.user_id,
        staffId: userDetails[0].staffId,
        enableFace: event.target.checked ? "1" : "0",
      },
    };
    dispatch(commonSaveData(data));
  };

  const handleCloseDialogForm = () => {
    // Reset form to original values
    if (formType === "qualification") {
      setUpdateStaff((preState) => ({
        ...preState,
        qualification: userDetails[0]?.qualificationDetails?.qualification || "",
        fromYear: userDetails[0]?.qualificationDetails?.fromYear || "",
        toYear: userDetails[0]?.qualificationDetails?.toYear || "",
        institute: userDetails[0]?.qualificationDetails?.institute || "",
      }));
    }
    if (formType === "address") {
      setUpdateStaff((preState) => ({
        ...preState,
        address: userDetails[0]?.addressDetails?.addressText || "",
        country: userDetails[0]?.addressDetails?.country || "1",
        city: userDetails[0]?.addressDetails?.city || "",
        state: userDetails[0]?.addressDetails?.state || "",
        pincode: userDetails[0]?.addressDetails?.pincode || "",
      }));
    }
    if (formType === "basic") {
      setUpdateStaff((preState) => ({
        ...preState,
        staff_name: userDetails[0]?.full_name || "",
        staff_mobile: userDetails[0]?.mobile_number || "",
        staff_personal_email: userDetails[0]?.personalDetails?.personalEmail || "",
        dob: userDetails[0]?.personalDetails?.dob || "",
        gender: userDetails[0]?.gender || "",
        marital_status: userDetails[0]?.personalDetails?.maritalStatus || "",
        marriageDate: userDetails[0]?.personalDetails?.marriageDate
          ? userDetails[0]?.personalDetails?.marriageDate.substring(0, 10)
          : "",
        spouseName: userDetails[0]?.personalDetails?.spouseName || "",
        emerg_cont_name: userDetails[0]?.personalDetails?.emergency_contact_name || "",
        emerg_cont_mobile: userDetails[0]?.personalDetails?.emergency_contact_mobile || "",
        emerg_cont_address: userDetails[0]?.personalDetails?.emergency_contact_address || "",
      }));
    }
    if (formType === "govtId") {
      setUpdateStaff((preState) => ({
        ...preState,
        aadharName: userDetails[0]?.personalDetails?.aadharName || "",
        aadharNumber: userDetails[0]?.personalDetails?.aadharNumber || "",
        panName: userDetails[0]?.personalDetails?.panName || "",
        panNumber: userDetails[0]?.personalDetails?.panNumber || "",
        uanNumber: userDetails[0]?.personalDetails?.uanNumber || "",
        pfAccountNumber: userDetails[0]?.personalDetails?.pfNumber || "",
        educationNum: userDetails[0]?.qualificationDetails?.educationNum || "",
      }));
    }

    setValidationErrors({});
    setTouchedFields({});
    setDialogForm(false);
  };

  // Render form field with validation
  const renderField = (item, colSize = "6") => {
    const isTouched = touchedFields[item.name];
    const error = validationErrors[item.name];
    const showError = isTouched && error;

    return (
      <Col sm={colSize} key={item.name} className="flex-column color-white mt-3">
        <label>
          {item.label}
          {item.required && <span style={{ color: "red", marginLeft: "2px" }}>*</span>}
        </label>
        
        {item.chi ? (
          <select
            name={item.name}
            onChange={handelChange}
            onBlur={handleBlur}
            className={`universal-input ${showError ? 'is-invalid' : ''}`}
            value={updateStaff[item.name] || ""}
          >
            {Array.isArray(item.chi) ? (
              item.chi.map((dv, i) => (
                <option key={i} value={dv.value}>
                  {dv.label}
                </option>
              ))
            ) : (
              <>
                <option value="1">India</option>
              </>
            )}
          </select>
        ) : (
          <input
            name={item.name}
            type={item.type || "text"}
            value={updateStaff[item.name] || ""}
            placeholder={item.placeholder}
            onChange={handelChange}
            onBlur={handleBlur}
            className={`universal-input ${showError ? 'is-invalid' : ''}`}
          />
        )}
        
        {showError && (
          <div className="invalid-feedback" style={{ display: 'block' }}>
            {error}
          </div>
        )}
      </Col>
    );
  };

  return (
    <>
      <Row>
        <Col sm={6} className="mb-3">
          <Row>
            <Col sm={12} className="mb-3">
              <Widgets
                icon={<WidgetsIcon icon={<CiUser />} title="Basic Details" />}
                button={
                  HasPermission("Personal Details", "edit") && (
                    <WidgetsButton
                      type="button"
                      icon={<RiEdit2Line className="btn-icon" />}
                      onClick={() => handleObjectList("basic")}
                    />
                  )
                }
                body={
                  <div className="mt-3">
                    {inputsOne.map((item, i) => (
                      <div key={i} className="flex-space-between">
                        <label>{item.label}</label>
                        <span>{updateStaff.staff_name}</span>
                      </div>
                    ))}

                    <div className="flex-space-between">
                      <label>Mobile Number</label>
                      <span>{updateStaff.staff_mobile}</span>
                    </div>

                    {inputsTwo.map((item, i) => (
                      <div key={i} className="flex-space-between">
                        <label>{item.label}</label>
                        <span>
                          {item.label == "Marital Status"
                            ? updateStaff[item.name] == "1"
                              ? "Married"
                              : updateStaff[item.name] == "2"
                                ? "Unmarried"
                                : updateStaff[item.name] == "3"
                                  ? "Widow"
                                  : "-"
                            : !updateStaff[item.name] ||
                              updateStaff[item.name] == "0000-00-00"
                              ? "-"
                              : item.label == "Gender"
                                ? updateStaff[item.name] == "1"
                                  ? "Male"
                                  : updateStaff[item.name] == "2"
                                    ? "Female"
                                    : "Other"
                                : updateStaff[item.name]}
                        </span>
                      </div>
                    ))}

                    <div className="flex-space-between">
                      <label>Emergency Contact Mobile Number</label>
                      <span>
                        {updateStaff.emerg_cont_mobile || "-"}
                      </span>
                    </div>
                    <div className="flex-space-between">
                      <label>Emergency Contact Member Relationship</label>
                      <span>
                        {updateStaff.emerg_cont_address || "-"}
                      </span>
                    </div>
                  </div>
                }
              />
            </Col>

            <Col sm={12}>
              <Widgets
                icon={
                  <WidgetsIcon
                    icon={<MdCastForEducation />}
                    title="Qualification Details"
                  />
                }
                button={
                  HasPermission("Personal Details", "edit") && (
                    <WidgetsButton
                      type="button"
                      icon={<RiEdit2Line className="btn-icon" />}
                      onClick={() => handleObjectList("qualification")}
                    />
                  )
                }
                body={
                  <div className="mt-3">
                    {qualification.map((item, i) => (
                      <div key={i} className="flex-space-between">
                        <label>{item.label}</label>
                        <span
                          style={{ maxWidth: "350px", textAlign: "justify" }}
                        >
                          {item.label == "Qualification"
                            ? qualification_.map((row) => {
                              return row.value == updateStaff[item.name]
                                ? row.label
                                : null;
                              }).filter(Boolean).join(", ") || "-"
                            : updateStaff[item.name]
                              ? item.name == "fromYear" || item.name == "toYear"
                                ? updateStaff[item.name].substring(0, 10)
                                : updateStaff[item.name]
                              : "-"}
                        </span>
                      </div>
                    ))}
                  </div>
                }
              />
            </Col>
          </Row>
        </Col>

        <Col sm={6} className="mb-3">
          <Row>
            <Col sm={12} className="mb-3">
              <Widgets
                icon={
                  <WidgetsIcon
                    icon={<CgFileDocument />}
                    title="Government IDs"
                  />
                }
                button={
                  HasPermission("Personal Details", "edit") && (
                    <WidgetsButton
                      type="button"
                      icon={<RiEdit2Line className="btn-icon" />}
                      onClick={() => handleObjectList("govtId")}
                    />
                  )
                }
                body={
                  <div className="mt-3">
                    {GovernmentIdsInputsOnes.map((item, i) => (
                      <div key={i} className="flex-space-between">
                        <label>{item.label}</label>
                        <span>
                          {updateStaff[item.name] || "-"}
                        </span>
                      </div>
                    ))}
                  </div>
                }
              />
            </Col>

            <Col sm={12} className="mb-3">
              <Widgets
                icon={
                  <WidgetsIcon
                    icon={<HiOutlineLocationMarker />}
                    title="Address Details"
                  />
                }
                button={
                  HasPermission("Personal Details", "edit") && (
                    <WidgetsButton
                      type="button"
                      icon={<RiEdit2Line className="btn-icon" />}
                      onClick={() => handleObjectList("address")}
                    />
                  )
                }
                body={
                  <div className="mt-3">
                    {AddressInfos.map((item, i) => (
                      <div key={i} className="flex-space-between">
                        <label>{item.label}</label>
                        <span
                          style={{ maxWidth: "350px", textAlign: "justify" }}
                        >
                          {item.label == "State"
                            ? states.map((row) => {
                              return row.value == updateStaff[item.name]
                                ? row.label
                                : null;
                              }).filter(Boolean).join(", ") || "-"
                            : item.label == "Country"
                              ? updateStaff[item.name] == "1"
                                ? "India"
                                : updateStaff[item.name] || "-"
                              : updateStaff[item.name] || "-"}
                        </span>
                      </div>
                    ))}
                  </div>
                }
              />
            </Col>

            <Col sm={12}>
              <Widgets
                icon={
                  <span className="color-white">Enable / Disable face</span>
                }
                button={
                  HasPermission("Personal Details", "edit") && (
                    <Switch
                      name="allow_punchin"
                      checked={isEnableFace == "1"}
                      onChange={handleFaceChange}
                      inputProps={{ "aria-label": "controlled" }}
                    />
                  )
                }
                body={
                  <>
                    <p className="color-white mt-3">
                      This feature lets you turn on or off facial recognition
                      for employee authentication and attendance tracking.
                    </p>
                    <br />
                    {staffImage && (
                      <Link
                        to={staffImage}
                        target="_blank"
                        className="mt-5 mb-3"
                      >
                        View Face
                      </Link>
                    )}
                  </>
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={dialogForm}
        onClose={handleCloseDialogForm}
        className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={handleCloseDialogForm}>
              X
            </span>
            <span className="title">
              {
                formType == "basic"
                  ? "Update Basic Details"
                  : formType == "govtId"
                    ? "Update Government IDs"
                    : formType == "address"
                      ? "Update Address Details"
                      : "Qualification Details"
              }
            </span>
          </div>
          <button className="universal-btn" onClick={preSubmit}>
            Save Changes
          </button>
        </DialogTitle>
        <DialogContent>
          {formType == "basic" && (
            <form onSubmit={handelSubmit}>
              <Row className="mt-3">
                {inputsOne.map((item) => renderField(item))}

                <Col sm="6" className="flex-column color-white mt-3">
                  <label>
                    Mobile Number
                    <span style={{ color: "red", marginLeft: "2px" }}>*</span>
                  </label>
                  <input
                    name="staff_mobile"
                    value={updateStaff.staff_mobile}
                    placeholder={"Enter Mobile Number"}
                    onChange={handelChange}
                    onBlur={handleBlur}
                    className={`universal-input ${touchedFields.staff_mobile && validationErrors.staff_mobile ? 'is-invalid' : ''}`}
                  />
                  {touchedFields.staff_mobile && validationErrors.staff_mobile && (
                    <div className="invalid-feedback" style={{ display: 'block' }}>
                      {validationErrors.staff_mobile}
                    </div>
                  )}
                </Col>

                {inputsTwo.map((item) => 
                  item.isVisible !== false && renderField(item)
                )}

                <Col sm="6" className="flex-column color-white mt-3">
                  <label>Emergency Contact Mobile Number</label>
                  <input
                    name="emerg_cont_mobile"
                    value={updateStaff.emerg_cont_mobile || ""}
                    placeholder={"Enter Mobile Number"}
                    onChange={handelChange}
                    onBlur={handleBlur}
                    className={`universal-input ${touchedFields.emerg_cont_mobile && validationErrors.emerg_cont_mobile ? 'is-invalid' : ''}`}
                  />
                  {touchedFields.emerg_cont_mobile && validationErrors.emerg_cont_mobile && (
                    <div className="invalid-feedback" style={{ display: 'block' }}>
                      {validationErrors.emerg_cont_mobile}
                    </div>
                  )}
                </Col>
                
                <Col sm="6" className="flex-column color-white mt-3">
                  <label>Emergency Contact Member Relationship</label>
                  <textarea
                    name={"emerg_cont_address"}
                    value={updateStaff.emerg_cont_address || ""}
                    onChange={handelChange}
                    onBlur={handleBlur}
                    placeholder={"Enter Address"}
                    className={`universal-input ${touchedFields.emerg_cont_address && validationErrors.emerg_cont_address ? 'is-invalid' : ''}`}
                    rows="3"
                  />
                  {touchedFields.emerg_cont_address && validationErrors.emerg_cont_address && (
                    <div className="invalid-feedback" style={{ display: 'block' }}>
                      {validationErrors.emerg_cont_address}
                    </div>
                  )}
                </Col>
              </Row>
              <button
                type="submit"
                id="submit-btn-bs-dt"
                style={{ display: "none" }}
              ></button>
            </form>
          )}

          {formType == "govtId" && (
            <form onSubmit={handelSubmit}>
              <Row className="mt-3">
                {GovernmentIdsInputsOnes.map((item) => renderField(item))}
              </Row>
              <button
                type="submit"
                id="submit-btn-bs-dt"
                style={{ display: "none" }}
              ></button>
            </form>
          )}

          {formType == "qualification" && (
            <form onSubmit={handelSubmit}>
              <Row className="mt-3">
                {qualification.map((item) => renderField(item))}
              </Row>
              <button
                type="submit"
                id="submit-btn-bs-dt"
                style={{ display: "none" }}
              ></button>
            </form>
          )}

          {formType == "address" && (
            <form onSubmit={handelSubmit}>
              <Row className="mt-3">
                {AddressInfos.map((item) => renderField(item))}
              </Row>
              <button
                type="submit"
                id="submit-btn-bs-dt"
                style={{ display: "none" }}
              ></button>
            </form>
          )}
        </DialogContent>
      </Dialog>
    </>
  );
};

const BankAccount = ({ user, userDetails, commonState, getUserDetails }) => {
  const dispatch = useDispatch();
  const toast = useGlobalToast();
  const empBankDetails = userDetails.length ? userDetails[0]?.bankDetails : null;

  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [isBankAccount, setIsBankAccount] = useState(true);
  const [accountList, setAccountList] = useState([]);

  const [chequeState, setChequeState] = useState({
    userId: user.user_id, // Don't convert to string unnecessarily
    staffId: userDetails[0]?.staffId,
    bankCheque: "",
    imageName: "",
  });

  const [accountData, setAccountData] = useState({
    userId: user.user_id,
    staffId: userDetails[0]?.staffId,
    bankAccountType: empBankDetails?.accountType,
    bankAccountNumber: empBankDetails?.bankAccountNumber,
    bankBranch: empBankDetails?.bankBranch,
    bankIfsc: empBankDetails?.bankIfsc,
    bankName: empBankDetails?.bankName,
  });

  const [accounts, setAccounts] = useState([]);
  
  useEffect(() => {
    if (userDetails.length && userDetails[0]?.bankDetails) {
      let data = [
        {
          bankAccountType: userDetails[0].bankDetails.accountType,
          bankAccountNumber: userDetails[0].bankDetails.bankAccountNumber,
          bankBranch: userDetails[0].bankDetails.bankBranch,
          bankIfsc: userDetails[0].bankDetails.bankIfsc,
          bankName: userDetails[0].bankDetails.bankName,
        },
      ];
      setAccounts(data);
    }
  }, [userDetails]);

  const getAccountList = useCallback(() => {
    if (user.user_id && userDetails[0]?.staffId) {
      let url = getEmployeeBankListFuncPath(user.user_id, userDetails[0].staffId);
      dispatch(commonGetDataTwo(url));
    }
  }, [user.user_id, userDetails, dispatch]);

  useEffect(() => {
    getAccountList();
  }, [getAccountList]);

  useEffect(() => {
    if (commonState.commonGetTwoSuccess) {
      setAccountList(commonState.commonGetTwoData);
    }
  }, [commonState.commonGetTwoSuccess]);

  const handleClose = () => {
    setValidated(false);
    setOpen(false);
    setIsBankAccount(true);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleOption = (e) => {
    const { value } = e.target;
    if (value == "upi") {
      setIsBankAccount(false);
      setAccountData({
        ...accountData,
        bank_or_upi: 2,
      });
    } else {
      setIsBankAccount(true);
      setAccountData({
        ...accountData,
        bank_or_upi: 1,
      });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setAccountData({
      ...accountData,
      [name]: value,
    });
  };

  const preSubmit = () => {
    document.getElementById("account-submit-btn").click();
  };

  const handleSubmit = (e) => {
    const form = e.currentTarget;
    e.preventDefault();
    e.stopPropagation();
    if (form.checkValidity() === false) {
      setValidated(true);
    } else {
      const data = {
        path: updateEmployeeBankAccountsPath,
        data: accountData,
      };
      dispatch(commonSaveData(data));
    }
  };

  useEffect(() => {
    if (commonState.commonSuccessOne) {
      toast.success(commonState.commonMessageOne);
      dispatch(initCommonState());
      getUserDetails();
      closePopup();
      setChequeState((pre) => ({
        ...pre,
        bankCheque: "",
        imageName: "",
      }));
    }
    if (commonState.commonErrorOne) {
      toast.error(commonState.commonMessageOne);
      dispatch(initCommonState());
      closePopup();
      setChequeState((pre) => ({
        ...pre,
        bankCheque: "",
        imageName: "",
      }));
    }
    if (commonState.commonSuccess) {
      getAccountList();
      toast.success(commonState.commonMessage);
      dispatch(initState());
      handleClose();
      getUserDetails();
    }
    if (commonState.commonError) {
      toast.error(commonState.commonMessage);
      dispatch(initState());
    }
  }, [commonState, dispatch, toast, getUserDetails, getAccountList]);

  const [isOpenPopup, setIsOpenPopup] = useState(false);

  const openPopup = () => {
    setIsOpenPopup(true);
  };
  
  const closePopup = () => {
    setIsOpenPopup(false);
  };

  const handleChequeChanges = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const { name, base64 } = await imageToBase64(file);
      setChequeState((preState) => ({
        ...preState,
        bankCheque: base64,
        imageName: name,
      }));
    }
  };

  const submitChequeDetail = () => {
    const data = {
      path: updateEmployeeBankChequePath,
      data: chequeState,
    };
    dispatch(commonSaveDataOne(data));
  };

  const heading = [
    {
      headerName: "Account Type",
      field: "accountType",
      pinned: "left",
      cellRenderer: (row) => {
        return <div>{row.data.accountType == "1" ? "Saving" : "Current"}</div>;
      },
    },
    {
      headerName: "Bank Account Number",
      field: "bankAccountNumber",
    },
    {
      headerName: "Bank Branch",
      field: "bankBranch",
    },
    {
      headerName: "Bank IFSC",
      field: "bankIfsc",
    },
    {
      headerName: "Bank Name",
      field: "bankName",
    },
  ];

  const paginationPageSize = 10;
  const paginationPageSizeSelector = [10, 20, 50, 100];

  return (
    <>
      <div
        className="PersonalDetails"
        style={{
          padding: "0px 8px",
          marginBottom: "15px",
        }}
      >
        <Widgets
          icon={<WidgetsIcon icon={<BsBank />} title="Bank Details" />}
          button={
            <>
              {HasPermission("Bank Account", "edit") && (
                <WidgetsButton
                  type="button"
                  variant="dark"
                  text="Update Bank Details"
                  icon={<FiPlus className="btn-icon" />}
                  onClick={preSubmit}
                />
              )}
            </>
          }
          body={
            <div style={{ overflow: "scroll", marginTop: "-30px" }}>
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Row className="mt-5">
                  <Col sm="6" className="mb-3">
                    <Form.Group>
                      <Form.Label
                        style={{ whiteSpace: "nowrap" }} className="color-white"
                      >
                        Account Holder Name
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        readOnly
                        name="full_name"
                        value={userDetails[0]?.full_name || ""}
                        placeholder="Enter account number"
                        className="universal-input"
                      />
                    </Form.Group>
                  </Col>

                  <Col sm="6" className="mb-3">
                    <Form.Group>
                      <Form.Label
                        style={{ whiteSpace: "nowrap" }} className="color-white"
                      >
                        Account Type
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        required={isBankAccount ? true : false}
                        name="bankAccountType"
                        value={accountData.bankAccountType || ""}
                        placeholder="Enter account holder name"
                        onChange={handleChange}
                        className="universal-input"
                      >
                        <option value="">Select type</option>
                        <option value="1">Saving</option>
                        <option value="2">Current</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please enter valid bank account type
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col sm="6" className="mb-3">
                    <Form.Group>
                      <Form.Label
                        style={{ whiteSpace: "nowrap" }} className="color-white"
                      >
                        Account Number
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={isBankAccount ? true : false}
                        name="bankAccountNumber"
                        value={accountData.bankAccountNumber || ""}
                        placeholder="Enter account number"
                        onChange={handleChange}
                        className="universal-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter valid account number
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col sm="6" className="mb-3">
                    <Form.Group>
                      <Form.Label
                        style={{ whiteSpace: "nowrap" }} className="color-white"
                      >
                        Bank Branch <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={isBankAccount ? true : false}
                        name="bankBranch"
                        value={accountData.bankBranch || ""}
                        placeholder="Enter bank branch"
                        onChange={handleChange}
                        className="universal-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter valid bank branch
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col sm="6" className="mb-3">
                    <Form.Group>
                      <Form.Label
                        style={{ whiteSpace: "nowrap" }} className="color-white"
                      >
                        IFSC Code <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={isBankAccount ? true : false}
                        name="bankIfsc"
                        value={accountData.bankIfsc || ""}
                        placeholder="Enter IFSC code"
                        onChange={handleChange}
                        className="universal-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter valid IFSC code
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>

                  <Col sm="6" className="mb-3">
                    <Form.Group>
                      <Form.Label
                        style={{ whiteSpace: "nowrap" }} className="color-white"
                      >
                        Bank Name <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        required={isBankAccount ? true : false}
                        name="bankName"
                        value={accountData.bankName || ""}
                        placeholder="Enter bank name"
                        onChange={handleChange}
                        className="universal-input"
                      />
                      <Form.Control.Feedback type="invalid">
                        Please enter valid bank name
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>

                <button
                  type="submit"
                  style={{ display: "none" }}
                  id="account-submit-btn"
                />
              </Form>
              
              {empBankDetails && (empBankDetails.bankCheque === "" || empBankDetails.bankCheque === null) && 
               HasPermission("Bank Account", "create") && (
                <button onClick={openPopup} className="universal-btn">
                  Upload Bank Cheque
                </button>
              )}

              <div className="check-container">
                <label className="color-white mb-2">Bank Cheque</label>
                <img
                  src={empBankDetails?.bankCheque || CheckImg}
                  alt="check"
                  style={{ cursor: "pointer" }}
                  onClick={openPopup}
                />
              </div>
            </div>
          }
        />
      </div>

      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={isOpenPopup}
        onClose={closePopup}
        className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={closePopup}>
              X
            </span>
            <span className="title">Add new cheque details</span>
          </div>
          <button className="universal-btn" onClick={submitChequeDetail}>
            Save Changes
          </button>
        </DialogTitle>
        <DialogContent>
          <Form className="mt-3">
            <Form.Group>
              <Form.Label className="color-white">Select File</Form.Label>
              <Form.Control
                type="file"
                onChange={handleChequeChanges}
                className="universal-input"
                id="fileInput"
                style={{ display: "none" }}
              />
              <label
                htmlFor="fileInput"
                className="custom-file-label universal-input-one"
              >
                {chequeState.imageName || "Click Here To Choose A File"}
              </label>
            </Form.Group>
          </Form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default UserInfo;